// extracted by mini-css-extract-plugin
export default {"wrapper":"s02_wrapper__dW9I0","title":"s02_title__WxyBB","desc":"s02_desc__HJyqB","features":"s02_features__ONQe8"};